export const GET_CURRENCY_DATA="GET_CURRENCY_DATA"
export const GET_DEFAULT_CURRENCY_DATA="GET_DEFAULT_CURRENCY"
export const ADD_CURRENCY="ADD_CURRENCY"
export const UPDATE_CURRENCY="UPDATE_CURRENCY"
export const DELETE_CURRENCY="DELETE_CURRENCY"
export const IS_DEFAULT="IS_DEFAULT"

